export enum SentimentCheck {
    Thumbs = 'thumbs',
    Stars = 'stars',
    Faces = 'faces'
}